export enum BydRhsConfigEnum {
  API_SCOPE = 'frontged',
  BIMDATA_API_SCOPE = 'FRONT_GED',
}
